import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/ubication')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <h1>Ubication</h1>
  )
}
